import { TableCell, TableRow } from '@mui/material'
import { BalanceReportLibraryColumnProps } from '@/state/balance-report/models'

export interface Props {
  row: BalanceReportLibraryColumnProps
}

const BalanceReportTableRowComponent = ({ row }: Props) => {
  return (
    <TableRow hover>
      <TableCell>{row.playerId}</TableCell>
      <TableCell>{row.username || '-'}</TableCell>
      <TableCell>{row.balanceText}</TableCell>
      <TableCell>{row.lastDayPlayedText}</TableCell>
      <TableCell>{row.lifetimeWLText}</TableCell>
    </TableRow>
  )
}

export default BalanceReportTableRowComponent
